import AppcastDisclaimer from './appcast-disclaimer'
import GenericDisclaimer from './generic-disclaimer'

export { AppcastDisclaimer, GenericDisclaimer }
